const createSidebarVariants = (isRTL = false) => ({
  initial: {
    x: isRTL ? 250 : -250,
    opacity: 0,
    width: 0,
  },
  animate: {
    x: 0,
    opacity: 1,
    width: "222px",
    transition: {
      duration: 0.6,
      width: {
        duration: 0.4,
        ease: [0.32, 1, 0.67, 1],
      },
    },
  },
  exit: {
    x: isRTL ? 250 : -250,
    opacity: 0,
    width: 0,
    transition: {
      duration: 1.2,
      width: {
        duration: 0.6,
        ease: [0.32, 0, 0.67, 0],
      },
    },
  },
})

const createContentVariants = (isRTL = false) => ({
  kioskV: {
    initial: {
      opacity: 0,
      gridTemplateColumns: "repeat(4, max-content)",
      scale: 1,
    },
    animate: {
      opacity: 1,
      gridTemplateColumns: "repeat(4, max-content)",
      [isRTL ? "marginRight" : "marginLeft"]: "0px",
      transition: {
        duration: 0.7,
        gridTemplateColumns: {
          duration: 0.5,
          delay: 0.2,
        },
      },
    },
    withSidebar: {
      opacity: 1,
      gridTemplateColumns: "repeat(3, max-content)",
      [isRTL ? "marginRight" : "marginLeft"]: "20px",
      transition: {
        duration: 0.6,
        gridTemplateColumns: {
          duration: 0.5,
          delay: 0.1,
        },
      },
    },
  },
  kioskH: {
    initial: {
      opacity: 0,
      gridTemplateColumns: "repeat(5, max-content)",
      scale: 1,
    },
    animate: {
      opacity: 1,
      gridTemplateColumns: "repeat(5, max-content)",
      [isRTL ? "marginRight" : "marginLeft"]: "0px",
      transition: {
        duration: 0.7,
        gridTemplateColumns: {
          duration: 0.5,
          delay: 0.2,
        },
      },
    },
    withSidebar: {
      opacity: 1,
      gridTemplateColumns: "repeat(4, max-content)",
      [isRTL ? "marginRight" : "marginLeft"]: "20px",
      transition: {
        duration: 0.6,
        gridTemplateColumns: {
          duration: 0.5,
          delay: 0.1,
        },
      },
    },
  },
})

export const LTRSidebarVariant = createSidebarVariants(false)
export const RTLSidebarVariant = createSidebarVariants(true)
export const LTRContentVariant = createContentVariants(false)
export const RTLContentVariant = createContentVariants(true)
